import { Editor, EditorProvider } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import {
  CommentBubbleMenu,
  CommentMark,
  DocCommentsProvider,
  TextEditor,
  TextEditorCommentsBar,
  TextEditorMenuBar,
  DocComment,
} from "@mjjs/ui";
import { TextStyle } from "@tiptap/extension-text-style";
import { TextAlign } from "@tiptap/extension-text-align";
import { jwtDecode } from "jwt-decode";
import React from "react";

// Combine extensions as needed
const extensions = [
  CommentMark,
  TextStyle,
  StarterKit.configure({
    heading: { levels: [1, 2, 3, 4, 5, 6] },
  }),
  TextAlign.configure({
    types: ["heading", "paragraph"],
    defaultAlignment: "left",
  }),
];

interface JobCaterEditorChildProps {
  docID: string;
  content: any;
  onUpdate: (params: { editor: any }) => void;
  comments: Record<string, DocComment>;
  onCommentsUpdated: (comments: Record<string, DocComment>) => void;
  onCommentAdded: (comment: DocComment) => Promise<void>;
  onCommentDeleted: (e: React.MouseEvent, id: string) => void;
  onCommentEdit: (e: React.FormEvent, id: string, comment: DocComment) => void;
  onSave: (editor: Editor) => Promise<any>;
  editable: boolean;
}

const JobCaterEditor = ({
  docID,
  content,
  onUpdate,
  comments,
  onCommentsUpdated,
  onCommentAdded,
  onCommentDeleted,
  onCommentEdit,
  onSave,
  editable = true,
}: JobCaterEditorChildProps) => {
  // @ts-ignore
  const token = localStorage.getItem("token");
  const userID = token ? jwtDecode(localStorage.getItem("token") ?? "")?.githubId : "";
  return (
    <DocCommentsProvider
      comments={comments}
      onChange={onCommentsUpdated}
      onAdd={onCommentAdded}
      docID={docID}
      userID={userID}
      onDelete={onCommentDeleted}
      onEdit={onCommentEdit}
    >
      <EditorProvider
        content={content}
        extensions={extensions}
        onUpdate={onUpdate}
        slotBefore={editable && <TextEditorMenuBar onSave={onSave} className="md:!top-0" />}
        editable={editable}
      >
        {editable && <CommentBubbleMenu />}
        <TextEditor />
      </EditorProvider>
      <TextEditorCommentsBar className={"md:!top-2 !max-h-[calc(100vh-6em)] glass"} />
    </DocCommentsProvider>
  );
};

export default JobCaterEditor;
